import { ReactNode } from "react";
import styles from "./ProgramBannerButton.module.scss";
import LoaderButton from "../../../../../common/core-ui/LoaderButton.tsx";

function Sparkle() {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="31"
      height="31"
      fill="none"
    >
      <path
        fill="#D6E7F7"
        fillOpacity=".3"
        d="M13.986 2.078C14.38.5 16.621.5 17.014 2.078l2.148 8.624c.14.56.576.997 1.136 1.136l8.624 2.148c1.578.393 1.578 2.635 0 3.028l-8.624 2.148a1.56 1.56 0 0 0-1.136 1.136l-2.148 8.624c-.393 1.578-2.635 1.578-3.028 0l-2.148-8.624a1.56 1.56 0 0 0-1.136-1.136l-8.624-2.148C.5 16.62.5 14.379 2.078 13.986l8.624-2.148a1.56 1.56 0 0 0 1.136-1.136l2.148-8.624Z"
        opacity=".6"
      />
    </svg>
  );
}

export default function ProgramBannerButton({
  children,
  onClick,
  disabled,
  loading = false,
  keepSameWidth = false,
  isLinkVariant = false,
  ...rest
}: {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  keepSameWidth?: boolean;
  isLinkVariant?: boolean;
}) {
  const className = isLinkVariant
    ? "vst-link vst-link-variant-white"
    : "vst-button-pill vst-button-variant-white";
  return (
    <div className={styles.container}>
      <div className={styles.sparkles}>
        <Sparkle />
        <Sparkle />
        <Sparkle />
      </div>
      <div>
        <LoaderButton
          loading={loading}
          keepSameWidth={keepSameWidth}
          loaderProps={{ color: "thematic" }}
          disabled={disabled}
          className={className}
          onClick={onClick}
          {...rest}
        >
          {children}
        </LoaderButton>
      </div>
    </div>
  );
}
